import React, { useEffect } from "react";

const GoogleReviewsOnly = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://elfsightcdn.com/platform.js";
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
    <div className="section-header">
        <h3 className="highlighted-text">
            Testimonials
        </h3>
    </div>
    <section className="review-container section-bg">
      <div className="elfsight-app-4aefbf62-8668-4800-b7d9-9e2e1874f0f2" data-elfsight-app-lazy></div>
    </section>
    </>
  );
};

export default GoogleReviewsOnly;
